
import {
  Component,
  Vue,
  Inject,
  Prop,
  Watch,
  Ref
} from "vue-property-decorator";
import api from "@/api";
import Tinymce from "@/components/Tinymce/index.vue";
import { CmsCategoryCreateOrUpdateDto } from "../../../api/appService";
import { ElForm } from "element-ui/types/form";

@Component({
  components: { Tinymce }
})
export default class CreateCmsCategory extends Vue {
  @Ref() readonly dataForm!: ElForm;

  @Prop({
    type: String,
    required: false,
    default: " "
  })
  title!: string;

  @Watch("show")
  async onShowChange(value: boolean) {
    if (value) {
      await api.cmsCategory
        .getForEdit({
          id: this.form!.id
        })
        .then(res => {
          this.form = res.data;
        });
    } else {
      this.form = {
        ...this.defaultData
      };
    }
    this.$nextTick(() => {
      this.dataForm.clearValidate();
    });
  }

  defaultData: CmsCategoryCreateOrUpdateDto = {
    name: undefined,
    categoryCode: undefined,
    description: undefined,
    id: 0
  };

  show = false;
  form: CmsCategoryCreateOrUpdateDto | undefined = {
    ...this.defaultData
  };

  async save() {
    console.log(this.form);
    (this.$refs.dataForm as any).validate(async (valid: boolean) => {
      if (valid) {
        if (this.form!.id) {
          await api.cmsCategory.update({
            body: this.form
          });
        } else {
          await api.cmsCategory.create({
            body: this.form
          });
        }
        this.show = false;
        this.$message.info("更新成功");
        this.$emit("onSave");
      }
    });
  }

  cancel() {
    this.show = false;
    // (this.$refs.dataForm as any).resetFields();
    // this.$emit("input", false);
  }

  roleRule = {
    name: [
      {
        required: true,
        message: "分类名称 必填",
        trigger: "blur"
      }
    ],
    categoryCode: [
      {
        required: true,
        message: "必填",
        trigger: "blur"
      }
    ],
    description: [
      {
        required: true,
        message: "必填",
        trigger: "blur"
      }
    ]
  };
}
